import React from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem } from '@mui/material';
import PopupState, {
  bindTrigger,
  bindMenu,
} from 'material-ui-popup-state';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';

/**
 * The kebab menu of a calendar event. The trigger button is supplied by the caller
 * so each kind of event keeps its own styling, while the popup wiring and the
 * accessible name of the icon-only trigger live in one place.
 */
const EventOptionsMenu = ({ TriggerButton, ariaLabel, options }) => (
  <PopupState variant="popover">
    {(popupState) => (
      <>
        <TriggerButton aria-label={ariaLabel} {...bindTrigger(popupState)}>
          <MoreVertIcon />
        </TriggerButton>
        <Menu {...bindMenu(popupState)}>
          {options.map(({ label, onClick, divider }) => (
            <MenuItem
              key={label}
              divider={divider}
              onClick={() => onClick(popupState.close)}
            >
              {label}
            </MenuItem>
          ))}
        </Menu>
      </>
    )}
  </PopupState>
);

EventOptionsMenu.propTypes = {
  TriggerButton: PropTypes.elementType.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  // Each option gets `popupState.close` so it can dismiss the menu on its own terms.
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    divider: PropTypes.bool,
  })).isRequired,
};

export default EventOptionsMenu;
